import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _4ded7e0e = () => interopDefault(import('../pages/404/index.vue' /* webpackChunkName: "pages/404/index" */))
const _511fe06e = () => interopDefault(import('../pages/checkUser/index.vue' /* webpackChunkName: "pages/checkUser/index" */))
const _fb51fd14 = () => interopDefault(import('../pages/contact/index.vue' /* webpackChunkName: "pages/contact/index" */))
const _585da42a = () => interopDefault(import('../pages/dashboard/index.vue' /* webpackChunkName: "pages/dashboard/index" */))
const _01f7bebe = () => interopDefault(import('../pages/learn-more/index.vue' /* webpackChunkName: "pages/learn-more/index" */))
const _ca194f82 = () => interopDefault(import('../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _317b468a = () => interopDefault(import('../pages/logout/index.vue' /* webpackChunkName: "pages/logout/index" */))
const _4990e1ba = () => interopDefault(import('../pages/register/index.vue' /* webpackChunkName: "pages/register/index" */))
const _357c9182 = () => interopDefault(import('../pages/soundcloud-callback/index.vue' /* webpackChunkName: "pages/soundcloud-callback/index" */))
const _7a310d39 = () => interopDefault(import('../pages/d/featured/index.vue' /* webpackChunkName: "pages/d/featured/index" */))
const _1103016a = () => interopDefault(import('../pages/d/new/index.vue' /* webpackChunkName: "pages/d/new/index" */))
const _75912edf = () => interopDefault(import('../pages/login/complete/index.vue' /* webpackChunkName: "pages/login/complete/index" */))
const _636bfb09 = () => interopDefault(import('../pages/login/forgot/index.vue' /* webpackChunkName: "pages/login/forgot/index" */))
const _738bafbf = () => interopDefault(import('../pages/login/reset/index.vue' /* webpackChunkName: "pages/login/reset/index" */))
const _a4f80386 = () => interopDefault(import('../pages/user/settings/index.vue' /* webpackChunkName: "pages/user/settings/index" */))
const _2585707a = () => interopDefault(import('../pages/d/featured/desktop.vue' /* webpackChunkName: "pages/d/featured/desktop" */))
const _5d004f90 = () => interopDefault(import('../pages/d/new/blank/index.vue' /* webpackChunkName: "pages/d/new/blank/index" */))
const _74df55ea = () => interopDefault(import('../pages/d/new/card/index.vue' /* webpackChunkName: "pages/d/new/card/index" */))
const _2b387145 = () => interopDefault(import('../pages/d/new/_dropId/index.vue' /* webpackChunkName: "pages/d/new/_dropId/index" */))
const _49319b0b = () => interopDefault(import('../pages/v2/d/_dropId/index.vue' /* webpackChunkName: "pages/v2/d/_dropId/index" */))
const _7c4333f4 = () => interopDefault(import('../pages/d/_dropId/index.vue' /* webpackChunkName: "pages/d/_dropId/index" */))
const _54ad5247 = () => interopDefault(import('../pages/m/_media/index.vue' /* webpackChunkName: "pages/m/_media/index" */))
const _5836986d = () => interopDefault(import('../pages/d/_dropId/preview/index.vue' /* webpackChunkName: "pages/d/_dropId/preview/index" */))
const _1df06e44 = () => interopDefault(import('../pages/d/_dropId/share/index.vue' /* webpackChunkName: "pages/d/_dropId/share/index" */))
const _b9dd1c3a = () => interopDefault(import('../pages/d/_dropId/test/index.vue' /* webpackChunkName: "pages/d/_dropId/test/index" */))
const _5c1a77da = () => interopDefault(import('../pages/d/_dropId/update/index.vue' /* webpackChunkName: "pages/d/_dropId/update/index" */))
const _3dd2b3c0 = () => interopDefault(import('../pages/m/_media/preview/index.vue' /* webpackChunkName: "pages/m/_media/preview/index" */))
const _0201b172 = () => interopDefault(import('../pages/d/_dropId/qr/_locationId/index.vue' /* webpackChunkName: "pages/d/_dropId/qr/_locationId/index" */))
const _df03a8b6 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _de867846 = () => interopDefault(import('../pages/_handle/index.vue' /* webpackChunkName: "pages/_handle/index" */))
const _7f00f7b0 = () => interopDefault(import('../pages/_handle/go/index.vue' /* webpackChunkName: "pages/_handle/go/index" */))
const _dad8b3f2 = () => interopDefault(import('../pages/_handle/nearby/index.vue' /* webpackChunkName: "pages/_handle/nearby/index" */))
const _9b739320 = () => interopDefault(import('../pages/_handle/go/reset/index.vue' /* webpackChunkName: "pages/_handle/go/reset/index" */))
const _462a8a04 = () => interopDefault(import('../pages/_handle/go/_category/index.vue' /* webpackChunkName: "pages/_handle/go/_category/index" */))
const _b0ba8e62 = () => interopDefault(import('../pages/_handle/p/_place/index.vue' /* webpackChunkName: "pages/_handle/p/_place/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404",
    component: _4ded7e0e,
    name: "404"
  }, {
    path: "/checkUser",
    component: _511fe06e,
    name: "checkUser"
  }, {
    path: "/contact",
    component: _fb51fd14,
    name: "contact"
  }, {
    path: "/dashboard",
    component: _585da42a,
    name: "dashboard"
  }, {
    path: "/learn-more",
    component: _01f7bebe,
    name: "learn-more"
  }, {
    path: "/login",
    component: _ca194f82,
    name: "login"
  }, {
    path: "/logout",
    component: _317b468a,
    name: "logout"
  }, {
    path: "/register",
    component: _4990e1ba,
    name: "register"
  }, {
    path: "/soundcloud-callback",
    component: _357c9182,
    name: "soundcloud-callback"
  }, {
    path: "/d/featured",
    component: _7a310d39,
    name: "d-featured"
  }, {
    path: "/d/new",
    component: _1103016a,
    name: "d-new"
  }, {
    path: "/login/complete",
    component: _75912edf,
    name: "login-complete"
  }, {
    path: "/login/forgot",
    component: _636bfb09,
    name: "login-forgot"
  }, {
    path: "/login/reset",
    component: _738bafbf,
    name: "login-reset"
  }, {
    path: "/user/settings",
    component: _a4f80386,
    name: "user-settings"
  }, {
    path: "/d/featured/desktop",
    component: _2585707a,
    name: "d-featured-desktop"
  }, {
    path: "/d/new/blank",
    component: _5d004f90,
    name: "d-new-blank"
  }, {
    path: "/d/new/card",
    component: _74df55ea,
    name: "d-new-card"
  }, {
    path: "/d/new/:dropId",
    component: _2b387145,
    name: "d-new-dropId"
  }, {
    path: "/v2/d/:dropId",
    component: _49319b0b,
    name: "v2-d-dropId"
  }, {
    path: "/d/:dropId",
    component: _7c4333f4,
    name: "d-dropId"
  }, {
    path: "/m/:media",
    component: _54ad5247,
    name: "m-media"
  }, {
    path: "/d/:dropId?/preview",
    component: _5836986d,
    name: "d-dropId-preview"
  }, {
    path: "/d/:dropId?/share",
    component: _1df06e44,
    name: "d-dropId-share"
  }, {
    path: "/d/:dropId?/test",
    component: _b9dd1c3a,
    name: "d-dropId-test"
  }, {
    path: "/d/:dropId?/update",
    component: _5c1a77da,
    name: "d-dropId-update"
  }, {
    path: "/m/:media?/preview",
    component: _3dd2b3c0,
    name: "m-media-preview"
  }, {
    path: "/d/:dropId?/qr/:locationId",
    component: _0201b172,
    name: "d-dropId-qr-locationId"
  }, {
    path: "/",
    component: _df03a8b6,
    name: "index"
  }, {
    path: "/:handle",
    component: _de867846,
    name: "handle"
  }, {
    path: "/:handle/go",
    component: _7f00f7b0,
    name: "handle-go"
  }, {
    path: "/:handle/nearby",
    component: _dad8b3f2,
    name: "handle-nearby"
  }, {
    path: "/:handle/go/reset",
    component: _9b739320,
    name: "handle-go-reset"
  }, {
    path: "/:handle/go/:category",
    component: _462a8a04,
    name: "handle-go-category"
  }, {
    path: "/:handle/p/:place",
    component: _b0ba8e62,
    name: "handle-p-place"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
